import * as types from "../types/CleaningTypes";
const selectedCleaningInitialState = null;
export const selectedCleaningReducer = (
  state = selectedCleaningInitialState,
  action
) => {
  switch (action.type) {
    case types.CLEANING_SELECT:
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/selectedCleaningReducer.js